import React from 'react';

import { AllPatientFragment } from '~/graphql/generated/graphql';

import { CheckinEntry } from './CheckinEntry';
import { DirectVisitor } from './DirectVisitor';
import { LineVisitor } from './LineVisitor';
import { Patient } from './Patient';
import { WebVisitor } from './WebVisitor';

type Props = {
  allPatient: AllPatientFragment;
};

export const AllPatient = React.memo((props: Props) => {
  const { allPatient } = props;

  if (allPatient.__typename === 'Patient') {
    return <Patient patient={allPatient} />;
  }

  if (allPatient.__typename === 'CheckinEntry') {
    return <CheckinEntry checkinEntry={allPatient} />;
  }

  if (allPatient.__typename === 'DirectVisitor') {
    return <DirectVisitor directVisitor={allPatient} />;
  }

  if (allPatient.__typename === 'LineVisitor') {
    return <LineVisitor lineVisitor={allPatient} />;
  }

  if (allPatient.__typename === 'WebVisitor') {
    return <WebVisitor webVisitor={allPatient} />;
  }

  return null;
});

AllPatient.displayName = 'AllPatient';
